import { Link } from 'react-router-dom'
import Section from '@/components/Section'
import { usePageTitle } from '@/components/usePageTitle'

export default function About() {
  usePageTitle('About', 'The International ColorMark Organization gives people the joy of naming their own color.')
  return (
    <>
      <Section image="/images/about-rainbow-sky.webp" overlay={0.1} tone="light" className="pt-40 md:pt-56 md:pb-28">
        <div className="mx-auto max-w-4xl">
          <h3>An exploration in color.</h3>
          <p className="mt-8">
            The International ColorMark Organization is dedicated to giving people the joy of being able to name and
            register their own unique color.
          </p>
          <p className="mt-6">
            ColorMark will brighten up your home with merchandise customized with your registered color. We are
            committed to exceptional customer service and only sell top quality home &amp; living products including
            posters, mugs, and stickers. We also have a large variety of products that can be customized and shipped
            anywhere in the United States.
          </p>
          <p className="mt-6">
            <Link to="/register">So come and get a color with ColorMark today!</Link>
          </p>
        </div>
      </Section>
      <Section className="text-center">
        <h1>
          <Link to="/register">Own the rainbow, with ColorMark</Link>
        </h1>
      </Section>
    </>
  )
}
